import GallerySlider from '../blocks/gallery-slider';

const templateDefault = {
  init() {
    $('.gallery').each(function (_i, element) {
      new GallerySlider(element);
    });
  }
}

export default templateDefault;
